import {Store} from '@discordapp/flux/Store';

import Dispatcher from '@developers/Dispatcher';
import ActionTypes from '@developers/actions/ActionTypes';

import type {Action, ActionFor} from '@developers/flow/Action';

let captchaModalProps: ActionFor<'SHOW_CAPTCHA_MODAL'> | null = null;

class CaptchaModalStore extends Store<Action> {
  static displayName = 'CaptchaModalStore';

  get captchaModalProps() {
    return captchaModalProps;
  }
}

export default new CaptchaModalStore(Dispatcher, {
  [ActionTypes.SHOW_CAPTCHA_MODAL](props) {
    captchaModalProps = props;
  },
  [ActionTypes.HIDE_CAPTCHA_MODAL]() {
    captchaModalProps = null;
  },
});
